import React from 'react';

interface WorkspaceLoaderProps {
  minHeight?: string;
}

export default function WorkspaceLoader({ minHeight = 'h-full' }: WorkspaceLoaderProps) {
  return (
    <div className={`flex items-center justify-center ${minHeight}`}>
      <svg className="animate-spin h-10 w-10 text-[#2563EB]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
      </svg>
    </div>
  );
}
